import clx from 'classnames';
import React from 'react';
import './BodyPageContainer.scss';

export interface IBodyPageContainerProps {
  noTopPadding?: boolean;
  children: React.ReactNode;
  className?: string;
}

export function BodyPageContainer(props: IBodyPageContainerProps) {
  return (
    <div
      className={clx('body-page-container', props.className, {
        'no-top-padding': props.noTopPadding
      })}
    >
      {props.children}
    </div>
  );
}
